export default __webpack_public_path__ + "media/arrow-ios-left.6aeb4b36.svg";